import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { config } from "node-config-ts";

if (config.DATADOG_APPLICATION_ENVIRONMENT !== "local") {
    datadogLogs.init({
        clientToken: 'pubb415eebd5e278e29c7f8ef4bac4bf47b',
        site: 'datadoghq.com',
        version: process.env.REACT_APP_VERSION,
        env: config.DATADOG_APPLICATION_ENVIRONMENT,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        service: 'axnadminui-vx'
    });
    
    datadogRum.init({
        applicationId: '7b025086-f9e1-4980-b0be-179c789467e3',
        clientToken: 'pubb415eebd5e278e29c7f8ef4bac4bf47b',
        site: 'datadoghq.com',
        version: process.env.REACT_APP_VERSION,
        env: config.DATADOG_APPLICATION_ENVIRONMENT,
        service: 'axnadminui-vx',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        startSessionReplayRecordingManually: true,
        trackUserInteractions: true,
        allowedTracingUrls: [
            /https:\/\/.*\.iddataweb\.com/,
            /https:\/\/.*\.iddataweb\.io/
        ]
    });   
}